import { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import _get from 'lodash/get';
import _map from 'lodash/map';
import { DASHBOARD_RESOURCES } from 'constant';
import { IFilterDetails, IHappyHourTemplate, IPageInfo, ISortInfo } from '../interfaces';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getHappyHoursData = useCallback(
		async ({
			pageDetails,
			app,
			sortDetails,
			filterDetails
		}: {
			pageDetails: IPageInfo;
			app: { displayName?: string; appName: string; isGold: boolean };
			sortDetails: ISortInfo[];
			filterDetails: IFilterDetails[];
		}) => {
			const { appName } = app;
			const result = await postData({
				endpoint: `/marketing/dashboard/${DASHBOARD_RESOURCES.happyHour}/getHappyHours`,
				queryParams: {
					appName
				},
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails
				}
			});
			let data = _get(result, ['data', 'data', 'hhTemplates'], []);
			data = _map(data, (row) => {
				const newRow = row;
				return newRow;
			});
			const listData = formatListData(data);
			const rowCount = _get(result, ['data', 'data', 'count'], 0);
			return { rowCount, data: listData };
		},
		[]
	);

	const requestCreateHappyHour = useCallback((appName: string, data: IHappyHourTemplate) => {
		return postData({
			endpoint: `/marketing/dashboard/${DASHBOARD_RESOURCES.happyHour}/createHappyHour`,
			body: { happyHour: data },
			queryParams: {
				appName
			}
		});
	}, []);

	const requestUpdateHappyHour = useCallback((appName: string, data: IHappyHourTemplate) => {
		return postData({
			endpoint: `/marketing/dashboard/${DASHBOARD_RESOURCES.happyHour}/updateHappyHour`,
			body: { happyHour: data },
			queryParams: {
				appName
			}
		});
	}, []);

	return {
		getHappyHoursData,
		requestUpdateHappyHour,
		requestCreateHappyHour
	};
};

export default useService;
